import React, { useState } from "react";
import { Button, Input, MenuSelect } from "./Form";
import Modal from "./Modals/Modal";
import { FaSave } from "react-icons/fa";
import { MdKeyboardArrowDown } from "react-icons/md";

function NewMaterial({ modal, setModal, state, setState, className, label = 'Add New Extra', onClick, loading }) {

    const [dropdown, setDropdown] = useState(false);
	const data = [{ name: "ml" }, { name: "dl" }, { name: "g" }, { name: "#" }];

    const handleChange = (e) => {
        setState({ ...state, [e.target.name]: e.target.value });
    }

    const handleDropDownChange = (e) => {
        setState({ ...state, unit: e.name });
    }

    return (
        <>
            <Modal isOpen={modal} closeModal={() => setModal(false)} title={"New Material"}>
                <Input label={"Name *"} placeholder={"Name"} color={true} name="name" value={state?.name} onChange={handleChange} />
                <Input label={"Code "} placeholder={"Code"} color={true} name="code" value={state?.code} onChange={handleChange} />
                <div className="" onClick={() => setDropdown(!dropdown)}>
                    <MenuSelect
                        className={"my-2"}
                        datas={data}
                        name="unit"
                        onClick={handleDropDownChange}
                        isMenuOpen={dropdown}
                        setIsMenuOpen={setDropdown}
                        staticMode>
                        <div className="flex flex-1 flex-col">
                            <div className="flex flex-1 w-full">Unit *</div>
                            <div className="flex flex-1 justify-between">
                                <span>{state?.unit}</span>
                                <MdKeyboardArrowDown className="text-lg" />
                            </div>
                        </div>
                    </MenuSelect>
                </div>
                <Input label={"Description"} placeholder={"Description"} color={true} name="description" value={state?.description} onChange={handleChange} />
                <Button className={"my-4"} label={"Save"} Icon={FaSave} onClick={onClick} loading={loading} />
            </Modal>
        </>
    );
}

export default NewMaterial;
